<template>
  <table
    class="table-total table table-base"
    :style="'table-layout: fixed; width: ' + getWidth() + 'px;'"
  >
    <tr>
      <th class="fixed fixed-add stripe_green"></th>
      <th
        class="fixed fixed01 show-workpattern"
        style="text-align: center; z-index: 3 !important"
      ></th>
      <th
        class="fixed fixed02 show-total"
        style="text-align: center; z-index: 3 !important"
      ></th>
      <th
        v-for="(day, index) in days"
        :key="index + 100"
        class="summary"
        style="text-align: center"
      ></th>
      <th
        v-for="(item, index) in work_categories"
        :key="index"
        class="stripe_green"
        style="text-align: center; width: 28px !important; border: none !important"
      ></th>
      <th
        class="stripe_green"
        style="text-align: center; width: 22px !important; border: none !important"
      ></th>
    </tr>
    <tbody>
      <FulltimeConversionRow
        :header="`常勤換算（予定）`"
        :list="fulltimeConversionPlanList"
      />
      <FulltimeConversionRow
        :header="`常勤換算（実績）`"
        :list="fulltimeConversionResultList"
      />
      <FulltimeConversionRow
        :header="`介護福祉士の常勤換算（予定）`"
        :list="fulltimeConversionCareWorkerPlanList"
      />
      <FulltimeConversionRow
        :header="`介護福祉士の常勤換算（実績）`"
        :list="fulltimeConversionCareWorkerResultList"
      />
    </tbody>
  </table>
</template>

<style>
.table thead th {
  vertical-align: middle;
}
.table-base {
  overflow-x: scroll;
  border-collapse: separate;
  border-spacing: 0;
  border: none !important;
  margin-bottom: 0;
}
.table-base th {
  position: sticky;
  top: 0;
  border: solid 1px #d2d6db !important;
  background-color: #f3f4f6 !important;
  word-break: break-all;
  z-index: 1 !important;
}
.table-base td {
  text-align: center;
  vertical-align: middle;
  word-break: break-all;
  border: solid 1px #d2d6db !important;
  background-color: #ffffff;
}

/* 通常モード */
.table-total th {
  height: 0px !important;
  color: #111927;
  font-size: 10px !important;
  font-weight: 500 !important;
  padding: 0px !important;
}
.table-total td {
  height: 25px !important;
  color: #111927;
  font-size: 15px !important;
  font-weight: 500 !important;
  padding: 0px !important;
}
.table-total tr {
  background-color: #ffffff !important;
}
.table-total .fixed {
  position: sticky;
  z-index: 2;
}
.table-total .fixed-add {
  width: 30px;
  min-width: 30px;
  max-width: 30px;
  left: 0px;
  border: none !important;
  z-index: 10 !important;
}
.table-total .fixed01 {
  font-size: 10px !important;
  width: 276px;
  min-width: 276px;
  max-width: 276px;
  left: 30px;
}
.table-total .fixed02 {
  font-size: 10px;
  width: 154px;
  min-width: 154px;
  max-width: 154px;
  left: 306px;
}
.summary-row-todal {
  font-size: 15px !important;
}
.table-total .summary {
  width: 42px !important;
  min-width: 42px !important;
  max-width: 42px !important;
}

/* 作成モード */
.table-total-edit th {
  font-size: 9px;
  font-weight: 500;
  height: 24px !important;
}
.table-total-edit td {
  font-size: 11px;
  width: 39px;
  min-width: 39px;
  max-width: 39px;
}
.table-total-edit .fixed {
  position: sticky;
  left: 0;
  z-index: 2;
  height: 36px;
}
.table-total-edit .fixed01 {
  font-size: 10px !important;
  width: 60px;
  min-width: 60px;
  max-width: 60px;
  left: 0;
}
.table-total-edit .summary {
  font-size: 9px !important;
  width: 39px !important;
  min-width: 39px !important;
  max-width: 39px !important;
}
</style>

<script>
import FulltimeConversionRow from '@/Pages/Shifts/Components/Table/SummaryTable/FulltimeConversionRow';

export default {
  name: 'FulltimeConversionTable',
  components: {
    FulltimeConversionRow,
  },
  props: {
    office: {
      type: Object,
      default: () => ({}),
    },
    days: {
      type: Array,
      default: () => [],
    },
    basic_infos: {
      type: Array,
      default: () => [],
    },
    shift_data: {
      type: Object,
      default: () => ({}),
    },
    workingHoursResultList: {
      type: Array,
      default: () => [],
    },
    workingHoursCareWorkerResultList: {
      type: Array,
      default: () => [],
    },
    careWorkerStaffList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      work_categories: [1, 2, 3, 4, 5, 6, 7, 8, 9],
    };
  },
  methods: {
    // tableの幅取得
    getWidth() {
      const day_width = 42;
      return 460 + this.days.length * day_width;
    },
    calcHoursFromTimeString(timeString) {
      const [hour, minute] = timeString.split(':');

      return Number.parseInt(hour) + Number.parseInt(minute) / 60;
    },
    calcByPercentage(hours, percentage) {
      return (hours * percentage) / 100;
    },
    hasShiftWorkingHours(data) {
      return data.shift?.workpattern?.working_hours;
    },
    floor(value, base = 0) {
      return Math.floor(value * 10 ** base) / 10 ** base;
    },
    getFulltimeConvList(workingHoursList) {
      const list = new Array(this.days.length).fill(0);
      const denominator = this.office.workinghours_per_day;

      if (denominator === 0) {
        return list;
      }

      let i = 0;
      for (const workingHours of workingHoursList) {
        const result = workingHours / denominator;

        list[i] = this.floor(result, 2);
        i++;
      }
      return list;
    },
    createKeyFromDateString(dateString) {
      return Number.parseInt(dateString.substring(8, 10) - 1);
    },
  },
  computed: {
    fulltimeConversionCareWorkerPlanList() {
      return this.getFulltimeConvList(this.careWorkerWorkingHoursList, this.careWorkerDenominator);
    },
    fulltimeConversionPlanList() {
      return this.getFulltimeConvList(this.workingHoursList, this.staffDenominator);
    },
    fulltimeConversionResultList() {
      return this.getFulltimeConvList(this.workingHoursResultList, this.staffDenominator);
    },
    fulltimeConversionCareWorkerResultList() {
      return this.getFulltimeConvList(this.workingHoursCareWorkerResultList, this.careWorkerDenominator);
    },
    careWorkerWorkingHoursList() {
      const list = new Array(this.days.length).fill(0);
      for (const info of this.basic_infos) {
        const key = `${info.office_staff_id}_${info.occupation_id}`;
        if (key in this.shift_data === false) {
          continue;
        }
        const shiftList = this.shift_data[key];
        const percentage = info.occupation_percentage ?? 0;

        for (const [dateString, data] of Object.entries(shiftList)) {
          if (!this.hasShiftWorkingHours(data)) {
            continue;
          }

          if (!this.staffIdSet.has(data.shift.staff_id)) {
            continue;
          }

          if (!this.careWorkerStaffList.includes(data.shift.staff_id)) {
            continue;
          }
          const i = this.createKeyFromDateString(dateString);
          const workHour = this.calcHoursFromTimeString(data.shift.workpattern.working_hours);

          list[i] += this.calcByPercentage(workHour, percentage);
        }
      }
      return list;
    },
    workingHoursList() {
      const list = new Array(this.days.length).fill(0);
      for (const info of this.basic_infos) {
        const key = `${info.office_staff_id}_${info.occupation_id}`;
        if (key in this.shift_data === false) {
          continue;
        }

        const shiftList = this.shift_data[key];
        const percentage = info.occupation_percentage ?? 0;

        for (const [dateString, data] of Object.entries(shiftList)) {
          if (!this.hasShiftWorkingHours(data)) {
            continue;
          }

          if (!this.staffIdSet.has(data.shift.staff_id)) {
            continue;
          }
          const i = this.createKeyFromDateString(dateString);
          const workHour = this.calcHoursFromTimeString(data.shift.workpattern.working_hours);

          list[i] += this.calcByPercentage(workHour, percentage);
        }
      }
      return list;
    },
    staffIdSet() {
      const set = new Set();
      for (const info of this.basic_infos) {
        set.add(info.staff_id);
      }
      return set;
    },
    careWorkerDenominator() {
      let total = 0;
      for (const info of this.basic_infos) {
        if (this.careWorkerStaffList.includes(info.staff_id)) {
          total += (this.office.workinghours_per_day * info.occupation_percentage) / 100;
        }
      }

      return total;
    },
    staffDenominator() {
      let total = 0;
      for (const info of this.basic_infos) {
        total += (this.office.workinghours_per_day * info.occupation_percentage) / 100;
      }

      return total;
    },
  },
};
</script>
